
export function getFormattedDate(millis: number) {
    if (millis <= 0) return 'Just Now'
    const date = new Date(millis);
    return date.toLocaleDateString('en-US')
}